if (!customElements.get('products-toolbar')) {
  class ProductsToolbar extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.filtersComponent = document.querySelector('facet-filters');
      this.filtersColumn = document.querySelector('.main-products-grid__filters');
      this.layoutSwitcher = this.querySelector('.products-toolbar__layout');
      this.compareToggle = document.getElementById('compare-switch');
      this.sortBy = this.querySelector('.products-toolbar__sort');
      this.productsGrid = document.querySelector('.main-products-grid');

      if (this.filtersColumn) {
        this.filterToggle = this.querySelector('.js-toggle-filters');
        if (this.filterToggle) {
          this.filterToggle.addEventListener('click', this.toggleFilters.bind(this));
        }
      }

      this.bindTramEvents();
      this.setupStickyBehavior();
      document.addEventListener('on:facet-filters:updated', () => {
        this.bindTramEvents();
        this.setupStickyBehavior();
      });

      if (this.layoutSwitcher) {
        this.layoutSwitcher.addEventListener('change', this.handleLayoutChange.bind(this));

        // Set the layout to the layout in localstorage
        const layout = theme.storageUtil.get('products-layout');
        if (layout && layout === 'list') {
          const toggle = document.getElementById(`${layout}-layout-opt`);
          if (toggle) toggle.click();
        }
      }

      if (this.compareToggle) {
        this.compareToggle.addEventListener('change', this.toggleCompare.bind(this));

        const isChecked = theme.storageUtil.get('compare-toggle', true);
        if (isChecked !== null) {
          this.toggleCompare(null, isChecked, true);
        } else {
          this.toggleCompare(null, this.compareToggle.checked, false);
        }

        setTimeout(() => {
          this.classList.add('transition-ready');
          this.productsGrid.classList.add('transition-ready');
        }, 500);
      } else if (theme.settings.compareToggle === 'none') {
        this.toggleCompare(null, true, false);
      }

      if (!this.filtersComponent && this.sortBy) {
        this.sortBy.addEventListener('change', ProductsToolbar.handleSortByChange);
      }
    }

    /**
     * Binds click events for Tramontina desktop & mobile filter & sort triggers.
     */
    bindTramEvents() {
      const facetFilters = document.querySelector('facet-filters');

      // 1. All filters button (Desktop) & Filter button (Mobile) -> Opens side drawer
      this.querySelectorAll('.js-open-tram-drawer').forEach((btn) => {
        btn.onclick = (evt) => {
          evt.preventDefault();
          this.closeAllDropdowns();
          if (facetFilters && typeof facetFilters.open === 'function') {
            facetFilters.open(btn);
          }
        };
      });

      // 2. Mobile Sort button -> Opens side drawer and expands sort accordion
      this.querySelectorAll('.tram-mobile-sort').forEach((btn) => {
        btn.onclick = (evt) => {
          evt.preventDefault();
          this.closeAllDropdowns();
          if (facetFilters && typeof facetFilters.open === 'function') {
            facetFilters.open(btn);
            const sortDetails = facetFilters.querySelector('#filter-sort');
            if (sortDetails) {
              sortDetails.open = true;
              setTimeout(() => {
                sortDetails.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 150);
            }
          }
        };
      });

      // 3. Desktop Pill Dropdown Toggles ("top-lined filter" dropdowns)
      this.querySelectorAll('.tram-pill-wrap').forEach((wrap) => {
        const toggleBtn = wrap.querySelector('.js-toggle-pill-dropdown');
        const dropdown = wrap.querySelector('.js-pill-dropdown');

        if (toggleBtn) {
          toggleBtn.onclick = (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            const isOpen = wrap.classList.contains('is-open');

            this.closeAllDropdowns();

            if (!isOpen) {
              wrap.classList.add('is-open');
              toggleBtn.setAttribute('aria-expanded', 'true');
              window.tramActiveOpenPillParam = wrap.dataset.paramName;
              this.positionPillDropdown(wrap);
            } else {
              window.tramActiveOpenPillParam = null;
            }
          };
        }

        if (dropdown) {
          dropdown.onclick = (evt) => {
            evt.stopPropagation();
          };
        }
      });

      // Restore previously open dropdown if any (after AJAX refresh)
      if (window.tramActiveOpenPillParam) {
        const targetWrap = this.querySelector(`.tram-pill-wrap[data-param-name="${CSS.escape(window.tramActiveOpenPillParam)}"]`);
        if (targetWrap) {
          targetWrap.classList.add('is-open');
          targetWrap.querySelector('.js-toggle-pill-dropdown')?.setAttribute('aria-expanded', 'true');
          this.positionPillDropdown(targetWrap);
        }
      }

      // Handle horizontal scrolling and position updates for filter pills
      const pillsContainer = this.querySelector('.tram-filter-pills');
      if (pillsContainer) {
        if (window.tramPillsScrollLeft) {
          pillsContainer.scrollLeft = window.tramPillsScrollLeft;
        }

        if (!pillsContainer._hasPillsScroll) {
          pillsContainer._hasPillsScroll = true;
          pillsContainer.addEventListener('scroll', () => {
            window.tramPillsScrollLeft = pillsContainer.scrollLeft;
            const openWrap = this.querySelector('.tram-pill-wrap.is-open');
            if (openWrap) {
              this.positionPillDropdown(openWrap);
            }
          }, { passive: true });

          pillsContainer.addEventListener('wheel', (evt) => {
            if (evt.deltaY !== 0 && pillsContainer.scrollWidth > pillsContainer.clientWidth) {
              evt.preventDefault();
              pillsContainer.scrollLeft += evt.deltaY;
            }
          }, { passive: false });
        }
      }

      // Global scroll and resize handlers to keep open dropdown aligned
      if (!this._hasGlobalListeners) {
        this._hasGlobalListeners = true;
        const updateOpenDropdown = () => {
          const openWrap = document.querySelector('.tram-pill-wrap.is-open');
          if (openWrap) {
            const tb = openWrap.closest('products-toolbar');
            if (tb && typeof tb.positionPillDropdown === 'function') {
              tb.positionPillDropdown(openWrap);
            }
          }
        };
        window.addEventListener('scroll', updateOpenDropdown, { passive: true });
        window.addEventListener('resize', updateOpenDropdown, { passive: true });
      }

      // 4. Desktop Sort by Dropdown Toggle
      const sortWrap = this.querySelector('.tram-sort-pill-wrap');
      if (sortWrap) {
        const sortBtn = sortWrap.querySelector('.js-toggle-sort-dropdown');
        const sortDropdown = sortWrap.querySelector('.js-sort-dropdown');

        if (sortBtn) {
          sortBtn.onclick = (evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            const isOpen = sortWrap.classList.contains('is-open');

            this.closeAllDropdowns();

            if (!isOpen) {
              sortWrap.classList.add('is-open');
              sortBtn.setAttribute('aria-expanded', 'true');
              window.tramActiveSortOpen = true;
            } else {
              window.tramActiveSortOpen = false;
            }
          };
        }

        if (sortDropdown) {
          sortDropdown.onclick = (evt) => {
            evt.stopPropagation();
          };
        }
      }

      if (window.tramActiveSortOpen && sortWrap) {
        sortWrap.classList.add('is-open');
        sortWrap.querySelector('.js-toggle-sort-dropdown')?.setAttribute('aria-expanded', 'true');
      }

      // 5. Global Document Click Listener to Close Open Dropdowns
      if (!this.hasDocClickListener) {
        this.hasDocClickListener = true;
        document.addEventListener('click', (evt) => {
          if (!evt.target.closest('.tram-pill-wrap') && !evt.target.closest('.tram-sort-pill-wrap')) {
            this.closeAllDropdowns();
          }
        });
      }

      // 6. Checkbox Inputs inside Dropdowns -> Sync with main facets form
      this.querySelectorAll('.js-dropdown-input').forEach((input) => {
        input.onchange = (evt) => {
          const form = document.getElementById('facets');
          if (form) {
            const mainInput = form.querySelector(`input[name="${CSS.escape(input.name)}"][value="${CSS.escape(input.value)}"]`);
            if (mainInput) {
              mainInput.checked = input.checked;
              mainInput.dispatchEvent(new Event('input', { bubbles: true }));
              mainInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        };
      });

      // 7. Sort Radio Inputs inside Sort Dropdown -> Sync with main facets form
      this.querySelectorAll('.js-dropdown-sort-radio').forEach((radio) => {
        radio.onchange = (evt) => {
          const form = document.getElementById('facets');
          if (form) {
            const mainRadio = form.querySelector(`input[name="sort_by"][value="${CSS.escape(radio.value)}"]`);
            if (mainRadio) {
              mainRadio.checked = true;
              mainRadio.dispatchEvent(new Event('input', { bubbles: true }));
              mainRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          this.closeAllDropdowns();
        };
      });

      // 8. Price Inputs & Sliders inside Price Dropdown
      this.querySelectorAll('.tram-dropdown-price-wrap').forEach((priceWrap) => {
        const numMin = priceWrap.querySelector('.js-dropdown-price-number-min');
        const numMax = priceWrap.querySelector('.js-dropdown-price-number-max');
        const slideMin = priceWrap.querySelector('.js-dropdown-slider-min');
        const slideMax = priceWrap.querySelector('.js-dropdown-slider-max');
        const sliderContainer = priceWrap.querySelector('.tram-price-sliders');

        if (sliderContainer && slideMin && slideMax) {
          let activeDropdownSlider = null;

          const updateDropdownSplit = () => {
            if (activeDropdownSlider) return;

            const minVal = Number(slideMin.value) || 0;
            const maxVal = Number(slideMax.value) || 0;
            const minLimit = Number(slideMin.min) || 0;
            const maxLimit = Number(slideMax.max) || 100;
            const range = maxLimit - minLimit || 1;

            const pctMin = Math.max(0, Math.min(100, ((minVal - minLimit) / range) * 100));
            const pctMax = Math.max(0, Math.min(100, ((maxVal - minLimit) / range) * 100));

            let splitPct = (pctMin + pctMax) / 2;
            if (splitPct < 1) splitPct = 1;
            if (splitPct > 99) splitPct = 99;

            slideMin.style.clipPath = `inset(0 ${100 - splitPct}% 0 0)`;
            slideMin.style.webkitClipPath = `inset(0 ${100 - splitPct}% 0 0)`;
            slideMin.style.zIndex = '3';

            slideMax.style.clipPath = `inset(0 0 0 ${splitPct}%)`;
            slideMax.style.webkitClipPath = `inset(0 0 0 ${splitPct}%)`;
            slideMax.style.zIndex = '2';
          };

          const startDropdownDrag = (slider) => {
            activeDropdownSlider = slider;
            slideMin.style.clipPath = 'none';
            slideMin.style.webkitClipPath = 'none';
            slideMax.style.clipPath = 'none';
            slideMax.style.webkitClipPath = 'none';

            if (slider === slideMin) {
              slideMin.style.zIndex = '10';
              slideMax.style.zIndex = '1';
            } else {
              slideMax.style.zIndex = '10';
              slideMin.style.zIndex = '1';
            }
          };

          const stopDropdownDrag = () => {
            if (!activeDropdownSlider) return;
            activeDropdownSlider = null;
            updateDropdownSplit();
          };

          slideMin.addEventListener('pointerdown', () => startDropdownDrag(slideMin));
          slideMin.addEventListener('touchstart', () => startDropdownDrag(slideMin), { passive: true });
          slideMin.addEventListener('mousedown', () => startDropdownDrag(slideMin));

          slideMax.addEventListener('pointerdown', () => startDropdownDrag(slideMax));
          slideMax.addEventListener('touchstart', () => startDropdownDrag(slideMax), { passive: true });
          slideMax.addEventListener('mousedown', () => startDropdownDrag(slideMax));

          window.addEventListener('pointerup', stopDropdownDrag);
          window.addEventListener('touchend', stopDropdownDrag, { passive: true });
          window.addEventListener('mouseup', stopDropdownDrag);

          slideMin.addEventListener('change', updateDropdownSplit);
          slideMax.addEventListener('change', updateDropdownSplit);

          updateDropdownSplit();
        }

        const syncPriceToMain = () => {
          const mainNumMin = document.getElementById('price-range-number-min');
          const mainNumMax = document.getElementById('price-range-number-max');
          if (mainNumMin && numMin) mainNumMin.value = numMin.value || '';
          if (mainNumMax && numMax) mainNumMax.value = numMax.value || '';
          if (mainNumMin) {
            mainNumMin.dispatchEvent(new Event('input', { bubbles: true }));
            mainNumMin.dispatchEvent(new Event('change', { bubbles: true }));
          }
        };

        if (numMin) numMin.onchange = syncPriceToMain;
        if (numMax) numMax.onchange = syncPriceToMain;

        if (slideMin) {
          slideMin.oninput = () => {
            if (slideMax && Number(slideMin.value) > Number(slideMax.value)) {
              slideMin.value = slideMax.value;
            }
            if (numMin) numMin.value = slideMin.value;
            syncPriceToMain();
          };
        }
        if (slideMax) {
          slideMax.oninput = () => {
            if (slideMin && Number(slideMax.value) < Number(slideMin.value)) {
              slideMax.value = slideMin.value;
            }
            if (numMax) numMax.value = slideMax.value;
            syncPriceToMain();
          };
        }
      });

      // 9. Reset Button in Dropdown Headers
      this.querySelectorAll('.js-dropdown-reset').forEach((resetBtn) => {
        resetBtn.onclick = (evt) => {
          evt.preventDefault();
          if (facetFilters && typeof facetFilters.applyFilters === 'function') {
            facetFilters.applyFilters(new URL(resetBtn.href, window.location.origin).searchParams.toString());
          }
        };
      });
    }

    /**
     * Closes all active desktop filter & sort dropdowns.
     */
    closeAllDropdowns() {
      this.querySelectorAll('.tram-pill-wrap.is-open').forEach((w) => {
        w.classList.remove('is-open');
        w.querySelector('.js-toggle-pill-dropdown')?.setAttribute('aria-expanded', 'false');
      });
      const sortWrap = this.querySelector('.tram-sort-pill-wrap.is-open');
      if (sortWrap) {
        sortWrap.classList.remove('is-open');
        sortWrap.querySelector('.js-toggle-sort-dropdown')?.setAttribute('aria-expanded', 'false');
      }
      window.tramActiveOpenPillParam = null;
      window.tramActiveSortOpen = false;
    }

    /**
     * Positions a desktop pill dropdown directly under its trigger button
     * without being clipped by parent overflow containers.
     */
    positionPillDropdown(wrap) {
      if (!wrap) return;
      const toggleBtn = wrap.querySelector('.js-toggle-pill-dropdown');
      const dropdown = wrap.querySelector('.js-pill-dropdown');
      if (!toggleBtn || !dropdown) return;

      const rect = toggleBtn.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) {
        this.closeAllDropdowns();
        return;
      }

      const pillsContainer = this.querySelector('.tram-filter-pills');
      if (pillsContainer) {
        const pRect = pillsContainer.getBoundingClientRect();
        if (rect.right < pRect.left + 5 || rect.left > pRect.right - 5) {
          this.closeAllDropdowns();
          return;
        }
      }

      dropdown.style.top = `${Math.round(rect.bottom)}px`;

      const dropdownWidth = dropdown.offsetWidth || 300;
      let leftPos = Math.round(rect.left);
      const maxLeft = window.innerWidth - dropdownWidth - 16;
      if (leftPos > maxLeft) {
        leftPos = maxLeft;
      }
      if (leftPos < 16) {
        leftPos = 16;
      }
      dropdown.style.left = `${leftPos}px`;
    }

    /**
     * Updates the UI to reflect the compare state
     * @param {object} evt - Change event object
     * @param {boolean} checked - Whether compare is enabled or not (optional)
     * @param {boolean} persist - Whether to persist the new state (optional)
     */
    toggleCompare(evt, checked = null, persist = true) {
      const isChecked = evt ? evt.target.checked : checked;
      this.productsGrid.dataset.compare = isChecked;

      const compareButton = document.getElementById('compare-drawer-open');
      compareButton.classList.toggle('is-out', !isChecked);

      if (!evt && this.compareToggle) this.compareToggle.checked = isChecked;

      if (persist && !Shopify.designMode) {
        theme.storageUtil.set('compare-toggle', isChecked);
      }

      // Load scripts/styles if not already loaded
      if (isChecked) {
        const resourcesTag = document.getElementById('compare-resources');
        if (resourcesTag) {
          const resources = JSON.parse(resourcesTag.textContent);
          resources.forEach((resource) => {
            if (resource.type === 'js') {
              const script = document.createElement('script');
              script.src = resource.path;
              document.head.appendChild(script);
            } else if (resource.type === 'css') {
              const link = document.createElement('link');
              link.href = resource.path;
              link.type = 'text/css';
              link.rel = 'stylesheet';
              document.head.appendChild(link);
            }
          });
          resourcesTag.remove();
        }
      }
    }

    /**
     * Toggles open/closed state of the filters on desktop.
     */
    toggleFilters() {
      this.filterToggle.classList.toggle('is-active');
      this.filtersOpen = this.filterToggle.classList.contains('is-active');
      this.filterToggle.setAttribute('aria-expanded', this.filtersOpen);

      if (theme.mediaMatches.lg) {
        this.filtersColumn.classList.toggle('lg:js-hidden', !this.filtersOpen);
        const productsList = document.querySelector('.main-products-grid__results > .grid');

        productsList.className = this.filtersOpen
          ? productsList.dataset.filtersOpenClasses
          : productsList.dataset.filtersClosedClasses;
      } else {
        this.filtersComponent.open();
      }
    }

    /**
     * Handles 'change' events on the layout switcher buttons.
     * @param {object} evt - Event object.
     */
    handleLayoutChange(evt) {
      this.productsGrid.dataset.layout = evt.target.value;
      theme.storageUtil.set('products-layout', evt.target.value);
    }

    /**
     * Handles when a sort by dropdown is changed (and filtering is disabled)
     * @param {object} evt - Event object.
     */
    static handleSortByChange(evt) {
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('sort_by', evt.detail.selectedValue);
      urlObj.hash = 'products-toolbar';
      window.location.href = urlObj.toString();
    }

    /**
     * Accurately calculates the visible sticky header bottom offset.
     * Prevents false gaps caused by measuring inner headers or invisible elements.
     */
    static getStickyHeaderBottom() {
      let bottom = 0;

      // 1. Check sticky announcement bar if present and visible at top
      const announcement = document.querySelector('.cc-announcement--sticky, [class*="announcement--sticky"]');
      if (announcement) {
        const aStyle = window.getComputedStyle(announcement);
        if ((aStyle.position === 'sticky' || aStyle.position === 'fixed') && aStyle.display !== 'none' && aStyle.visibility !== 'hidden') {
          const aRect = announcement.getBoundingClientRect();
          if (aRect.bottom > 0 && aRect.top <= 2) {
            bottom = Math.max(bottom, aRect.bottom);
          }
        }
      }

      // 2. Check sticky header container (store-header or .cc-header--sticky)
      const header = document.querySelector('store-header') || document.querySelector('.cc-header--sticky');
      if (header) {
        const hStyle = window.getComputedStyle(header);
        const isSticky = hStyle.position === 'sticky' || hStyle.position === 'fixed' ||
                         header.classList.contains('cc-header--sticky') ||
                         header.dataset.isSticky === 'true' ||
                         header.closest('.cc-header--sticky');
        if (isSticky && hStyle.display !== 'none' && hStyle.visibility !== 'hidden') {
          const hRect = header.getBoundingClientRect();
          // If the header is stuck at the top or below announcement
          if (hRect.bottom > 0 && hRect.top <= (bottom + 4)) {
            bottom = Math.max(bottom, hRect.bottom);
          }
        }
      }

      return Math.max(0, Math.round(bottom));
    }

    /**
     * Handles sticky positioning offset and adds .is-stuck class on scroll
     */
    setupStickyBehavior() {
      if (this._hasStickyBehavior) return;
      this._hasStickyBehavior = true;

      window.getTramontinaStickyHeaderBottom = ProductsToolbar.getStickyHeaderBottom;

      const updateStickyOffset = () => {
        const finalTop = ProductsToolbar.getStickyHeaderBottom();
        document.documentElement.style.setProperty('--tram-toolbar-sticky-top', `${finalTop}px`);

        const tbRect = this.getBoundingClientRect();
        const isStuck = tbRect.top <= (finalTop + 2);
        this.classList.toggle('is-stuck', isStuck);

        // Dynamically compute sticky top for mobile active pills bar
        const isMobile = window.innerWidth < 900;
        const stickMobile = this.dataset.stickMobile === 'true' || this.classList.contains('is-sticky-mobile');
        const tbHeight = (isMobile && stickMobile) ? (this.offsetHeight || 50) : 0;
        const pillsStickyTop = finalTop + tbHeight;
        document.documentElement.style.setProperty('--tram-active-pills-sticky-top', `${pillsStickyTop}px`);

        const pillsBar = document.getElementById('tram-mobile-active-pills-bar');
        if (pillsBar) {
          const pRect = pillsBar.getBoundingClientRect();
          const isPillsStuck = pRect.top <= (pillsStickyTop + 2);
          pillsBar.classList.toggle('is-stuck', isPillsStuck);
        }
      };

      updateStickyOffset();
      window.addEventListener('scroll', updateStickyOffset, { passive: true });
      window.addEventListener('resize', updateStickyOffset);
    }
  }

  customElements.define('products-toolbar', ProductsToolbar);
}
